import { IEntity, IHasOwner, IIdName, IIdNameDateTime } from "./id-name";
import { IDeletedParam, IPageRequestParams, IQueryStrictParams } from "./page";
import { JobBuildStatus } from "./buildable";

export interface IApplicationFilterParams extends IQueryStrictParams {
    bucket?: string;
}

export interface IApplicationPageRequestParams extends
    IPageRequestParams,
    IApplicationFilterParams,
    IDeletedParam {

    fields?: (keyof IApplicationListItem)[];
}

export interface IApplicationListItem extends IIdNameDateTime<string>, IHasOwner {
    buckets?: IEntity<string>[];
}

export interface IApplicationDetailsItem extends IIdNameDateTime<string>, IHasOwner {
    credentials: IAccessCredentialListItem[];
}

export interface IApplicationUpdateRequest extends IIdName<string> {
}

export interface IApplicationCreateRequest extends Omit<IApplicationUpdateRequest, 'id'> {
}


export interface IAccessCredentialsFilterParams {
    q?: string;
    strict?: boolean;
    bucket?: string;
}

export interface IAccessCredentialsPageRequestParams extends
    IPageRequestParams,
    IDeletedParam,
    IAccessCredentialsFilterParams {

    fields?: (keyof IAccessCredentialListItem)[];
}

export interface IAccessCredentialListItem extends IIdNameDateTime<string>, IHasOwner {
    scope: AccessCredentialsScopeName;
    accessKey: string;
    bucketId: string;
    applicationId: string;

    bucket?: IIdName<string>;
    application?: IIdName<string>;

    status: JobBuildStatus;
}

export interface IAccessCredentialCreateRequest extends Pick<IAccessCredentialListItem, 'name' | 'scope' | 'bucketId'> {}

export interface IAccessCredentialCreateResponse extends IAccessCredentialCreateRequest, IEntity<string> {
    accessKey: string;
    accessSecret: string;
}

export enum AccessCredentialsScope {
    Read = 1,
    Write = 2,
    Full = 3
}

type ScopePermissionDictType = {
    [k in AccessCredentialsScopeName]: AccessCredentialsScopePermission[];
};

export enum AccessCredentialsScopePermission {
    Read = 'read',
    Write = 'write',
    Delete = 'delete',
}

export const scopePermissionDict: ScopePermissionDictType = {
    'read': [AccessCredentialsScopePermission.Read],
    'write': [AccessCredentialsScopePermission.Read, AccessCredentialsScopePermission.Write],
    'full': [AccessCredentialsScopePermission.Read, AccessCredentialsScopePermission.Write, AccessCredentialsScopePermission.Delete],
};

export type AccessCredentialsScopeName = Uncapitalize<keyof typeof AccessCredentialsScope>;

export enum AccessCredentialsSortField {
    Name = "name",
    Scope = "scope",
    Bucket = "bucket",
    Application = "application",
}

export const AccessCredentialListDefaultFields: (keyof IAccessCredentialListItem)[] = ['id', 'name', 'scope', 'bucket', 'application', 'ownerId', 'owner'];
